import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '@services/enviroment/environment.service';
import {
  AuditEventsListResponse,
  AuditEventsListParams,
  AuditCleanupResponse,
} from '@interfaces/audit';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject(EnvironmentService);
  private readonly apiUrl = this.environmentService.getValue('apiUrl');

  list(params: AuditEventsListParams = {}): Observable<AuditEventsListResponse> {
    let httpParams = new HttpParams();
    if (params.action != null && params.action !== '') {
      httpParams = httpParams.set('action', params.action);
    }
    if (params.origin === 'webapp' || params.origin === 'mobile') {
      httpParams = httpParams.set('origin', params.origin);
    }
    if (params.entity_type != null && params.entity_type !== '') {
      httpParams = httpParams.set('entity_type', params.entity_type);
    }
    if (params.entity_id != null && params.entity_id !== '') {
      httpParams = httpParams.set('entity_id', params.entity_id);
    }
    if (params.actor_id != null && params.actor_id !== '') {
      httpParams = httpParams.set('actor_id', params.actor_id);
    }
    if (params.from != null && params.from !== '') {
      httpParams = httpParams.set('from', params.from);
    }
    if (params.to != null && params.to !== '') {
      httpParams = httpParams.set('to', params.to);
    }
    if (params.limit != null) {
      httpParams = httpParams.set('limit', params.limit.toString());
    }
    if (params.offset != null) {
      httpParams = httpParams.set('offset', params.offset.toString());
    }
    return this.http.get<AuditEventsListResponse>(
      `${this.apiUrl}/admin/audit-events`,
      { params: httpParams }
    );
  }

  cleanup(days: number = 90): Observable<AuditCleanupResponse> {
    const params = new HttpParams().set('days', days.toString());
    return this.http.post<AuditCleanupResponse>(
      `${this.apiUrl}/admin/audit-events/cleanup`,
      null,
      { params }
    );
  }
}
